import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './i18n/config';  // Import i18n configuration
import { LanguageProvider } from './i18n/LanguageContext';
import App from './App';
import Providers from './application/providers/Providers';
import { HelpProvider } from './application/context/HelpContext';
import './index.css';

async function enableMocking() {
  // when running playwright tests, we need to set the cookie to simulate the user being logged in
  if (import.meta.env.VITE_PLAYWRIGHT === 'true') {
    document.cookie = 'ipciam_expiresAt=22222222222222222222; Path=/; Secure; SameSite=none';
  } else {
    if (import.meta.env.VITE_USE_MOCKS === 'true') {
      const { worker } = await import('./mocks/browser.ts');
      await worker.start();
    }
  }

  return;
}

enableMocking().then(() =>
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <LanguageProvider>
        <Providers>
          <BrowserRouter>
            <HelpProvider>
              <App />
            </HelpProvider>
          </BrowserRouter>
        </Providers>
      </LanguageProvider>
    </React.StrictMode>,
  ),
);
